import { render } from "./UserDocs.vue?vue&type=template&id=8359b6ae"
import script from "./UserDocs.vue?vue&type=script&lang=js"
export * from "./UserDocs.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__